
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/city-builder",
      function () {
        return require("private-next-pages/city-builder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/city-builder"])
      });
    }
  